import React from 'react';
import { Skeleton } from 'antd';

export const TestSkeleton: React.FC = () => (
  <>
    <div className="max-w-screen mx-auto mt-10 space-y-5">
      <div className="flex items-center justify-between rounded-xl bg-white p-4">
        <Skeleton.Button active className="!w-25 !h-5" />
        <Skeleton.Button active className="!h-5 !w-80" />
        <Skeleton.Button active className="!w-25 !h-5" />
      </div>
      <div className="space-y-4 rounded-xl bg-white p-4">
        <div className="flex items-center justify-between">
          <Skeleton.Button active className="!w-25 !h-5" />
          <Skeleton.Button active className="!h-5" />
        </div>
        <Skeleton active className="!h-5" />
        <div className="grid grid-cols-2 gap-3">
          <Skeleton.Button active className="!h-13 !w-full !rounded-xl" />
          <Skeleton.Button active className="!h-13 !w-full !rounded-xl" />
          <Skeleton.Button active className="!h-13 !w-full !rounded-xl" />
          <Skeleton.Button active className="!h-13 !w-full !rounded-xl" />
        </div>
      </div>

      <div className="space-y-4 rounded-xl bg-white p-4">
        <div className="flex items-center justify-between">
          <Skeleton.Button active className="!w-25 !h-5" />
          <Skeleton.Button active className="!h-5" />
        </div>
        <Skeleton.Button active className="!w-3/4 !h-5" />
        <div className="grid grid-cols-2 gap-3">
          <Skeleton.Button active className="!h-101 !w-full !rounded-xl" />
          <Skeleton.Button active className="!h-101 !w-full !rounded-xl" />
        </div>
      </div>
    </div>
  </>
);
